"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEATURE_FLAGS = void 0;
exports.FEATURE_FLAGS = [
    'AI_VACCINATION_DOCUMENTS',
    'BILLING_INVOICES',
    'FACILITY_SHIFT_BONUS',
    'HELP_SUPPORT_PAGE',
    'I9_FORM_ENABLED',
    'ORIENTATION_OPPORTUNITIES',
    'ORIENTATION_OPPORTUNITY_MESSAGING',
];
//# sourceMappingURL=feature-flags.js.map